<template>
  <s-section
    class="product-reward"
    type="bordered"
  >
    <div class="row flex-md-row-reverse">
      <div
        v-if="imageSrc"
        class="col-md-3 product-reward__image-container"
      >
        <img
          v-lazy-load
          :data-src="imageSrc"
          :alt="imageAlt"
          class="product-reward__image img-fluid"
        >
      </div>
      <div class="col-xl-6 col-md-7 product-reward__content-container">
        <h2
          v-if="title"
          class="product-reward__title"
          v-html="title"
        ></h2>
        <p
          v-if="description"
          class="product-reward__description"
          v-html="description"
        ></p>
        <slot></slot>
      </div>
    </div>
  </s-section>
</template>

<script>
export default {
  name: 'ProductReward',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    imageSrc: {
      type: String,
      default: ''
    },
    imageAlt: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.product-reward {
  .btn {
    margin-top: 24px;
  }
}

.product-reward__content-container {
  align-self: center;
}

.product-reward__image-container {
  align-self: center;
  padding-left: 32px;

  @media (max-width: $breakpoint-lg) {
    padding-left: 16px;
  }

  @media (max-width: $breakpoint-md) {
    max-width: 220px;
    padding-left: 10px;
  }
}

.product-reward__image {
  display: block;
  max-width: 80%;
  max-height: 160px;
  margin: 0 auto;

  @media (max-width: $breakpoint-lg) {
    max-width: 100%;
    margin: 0 0 40px;
  }
}
</style>